import React, {useCallback, useContext, useEffect, useState} from 'react';
import {isMobile} from 'react-device-detect';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import {AlertsFilterContext} from '../../services/alerts-filters/alerts-filters.context';
import {analyticsEvent} from '../../utils/analytics';
import {AlertsFilterTransportsComponent} from './alerts-filter-transports/alerts-filter-transports';
import {AlertsFilterWarningsComponent} from './alerts-filter-warnings/alerts-filter-warnings';
import './alerts-filter.scss';
import {DataContext} from '../../services/data-v2/data.context';
import {translate} from '../../services/translation/translationUtils';
import {warningsFilterActive} from '../../moks/alertsMockList';

export function AlertsFilterComponent() {
    const {t} = useTranslation();
    const filterService = useContext(AlertsFilterContext);
    const [filtersTransports, setFiltersTransports] = useState(filterService.filtersTransports);
    const [filtersWarnings, setFiltersWarnings] = useState(filterService.filtersWarnings);
    const [filterTransportsOptions, setFilterTransportsOptions] = useState<any>([]);
    const [filterWarningOptions, setFilterWarningOptions] = useState<any>([]);
    const {db, pinSet, services} = useContext(DataContext);

    const history = useHistory();

    const goBack = () => {
        history.goBack();
    };

    const changeActiveFilterTransports = (filterOption: any) => {
        analyticsEvent('Alertes i incidències', 'alerts_filteroptions_click');
        let addFilter = true;
        filtersTransports.forEach((t: any, index: number) => {
            if (t.slug === filterOption.slug) {
                // Copia temporal del array
                const tempFilter = filtersTransports.concat([]);
                tempFilter.splice(index, 1);
                setFiltersTransports(tempFilter);
                filterService.settmpFiltersTransportsctx(tempFilter);
                addFilter = false;
            }
        });
        if (addFilter) {
            let tmp: any = [];
            if (filtersTransports.length == 0) {
                filterTransportsOptions.forEach((option: any) => {
                    if (option.slug != filterOption.slug) {
                        tmp = tmp.concat(option);
                    }
                });
            } else {
                tmp = filtersTransports.concat(filterOption);
            }
            setFiltersTransports(tmp);
            filterService.settmpFiltersTransportsctx(tmp);
        }
    };
    const changeActiveFilterWarnings = (filterOption: any) => {
        analyticsEvent('Alertes i incidències', 'alerts_filteroptions_click');
        let addFilter = true;
        filtersWarnings.forEach((t: any, index: number) => {
            if (t.id === filterOption.id) {
                // copia temporal del array
                const tempFilter = filtersWarnings.concat([]);
                tempFilter.splice(index, 1);
                setFiltersWarnings(tempFilter);
                filterService.setTempFiltersWarningsctx(tempFilter);
                addFilter = false;
            }
        });
        if (addFilter) {
            let tmp: any = [];
            if (filtersWarnings.length == 0) {
                filterWarningOptions.forEach((option: any) => {
                    if (option.id != filterOption.id) {
                        tmp = tmp.concat(option);
                    }
                });
            } else {
                tmp = filtersWarnings.concat(filterOption);
            }
            setFiltersWarnings(tmp);
            filterService.setTempFiltersWarningsctx(tmp);
        }
    };

    const activeFilters = () => {
        filterService.setFiltersWarnings();
        filterService.setFiltersTransports();
        goBack();
    };

    const resetFilters = () => {
        setFiltersWarnings([]);
        setFiltersTransports([]);
        filterService.setTempFiltersWarningsctx([]);
        filterService.settmpFiltersTransportsctx([]);
        filterService.setFiltersWarnings();
    };

    let style = {};
    if (isMobile) {
        style = {
            'maxHeight': '90vh',
        } as React.CSSProperties;
    }

    useEffect(() => {
        if (filterTransportsOptions.length == 0) {
            getTransportsFilters();
            setFilterWarningOptions(warningsFilterActive);
        }
    }, [filterTransportsOptions]);

    const getTransportsFilters = useCallback(async () => {
        const servicesData: any[] = [];
        const serviceGroups = await db?.dataSources?.serviceGroups.find({
            selector: {
                parent: {$in: [35]},
            },
            sort: [{slug: 'asc'}],
        }) || [];
        for (const serviceGroup of serviceGroups) {
            if (pinSet && services) {
                const s = services.filter((service) => service.groupSlug === serviceGroup.slug)
                    .map((service) => {
                        return {
                            icon: pinSet[service.slug]?.icon,
                            iconDark: pinSet[service.slug]?.iconDark,
                            slug: service.slug,
                            name: translate(service.name),
                            active: db?.dataSources?.stops.slugFilter[service.slug] || false,
                            color: service.color,
                        };
                    });

                if (s.length) {
                    servicesData.push(s);
                }
            }
        }
        const serviceDataArray = [].concat(...servicesData);
        setFilterTransportsOptions(serviceDataArray);
    }, [db, pinSet, services]);

    return <div className="alerts-filters-box" style={style}>
        <div className="filters-info">
            <AlertsFilterTransportsComponent
                filters={filtersTransports}
                filterOptions={filterTransportsOptions}
                changeActiveFilter={changeActiveFilterTransports}
            />
            <AlertsFilterWarningsComponent
                filters={filtersWarnings}
                filterOptions={filterWarningOptions}
                changeActiveFilter={changeActiveFilterWarnings}
            />
        </div>
        {(!isMobile) ?
            <div className="filters-buttons">
                <button
                    className="btn-filter btn-filter-delete"
                    onClick={resetFilters}
                >
                    {t('translation:web_alert_filter_delete')}
                </button>
                <button
                    className="btn-filter btn-filter-apply"
                    onClick={activeFilters}
                >
                    {t('translation:misc_alert_filter_apply')}
                </button>
            </div> : ''
        }
    </div>
    ;
}
